.me-dropdown {
  @include desktop {
    &:has(.me-dropdown__menu dropdown-menu-type-1),
    &:has(dropdown-menu-type-1) {
      position: relative;
    }
  }
}

.dropdown-menu-type-1 {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
